import Payment from './Payment';
import SearchPanel from './SearchPanel';
export default class Components {
    constructor() {
        Object.defineProperty(this, "payment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Payment()
        });
        Object.defineProperty(this, "searchPanel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SearchPanel()
        });
    }
    get storageKey() {
        return 'components';
    }
    load() {
        this.searchPanel.load();
    }
    save() {
        this.searchPanel.save();
    }
}
